import { $enum } from "ts-enum-util";

import { Icons } from "src/library/components/Icon/types";

import { ProductRelatedGroupSettings } from "../api/products.api";

export default (relatedGroupSettings: ProductRelatedGroupSettings): Icons => {
  if (!relatedGroupSettings) {
    return Icons.WARN;
  }

  if (relatedGroupSettings.icon && $enum(Icons).getValues().includes(relatedGroupSettings.icon)) {
    return relatedGroupSettings.icon as Icons;
  }

  return Icons.WARN;
};
